export default __webpack_public_path__ + "static/logo-2ff1f2072383b5b44aeea958f60a90f6.svg";